import mixins from 'vue-typed-mixins';

import { Eフェーズ種別, Eモニタリング損益差異分析基準値, Eモニタリング業績予測基準値 } from '@/openapi/enum';

import { PrintConfig, PrintDialogStyle } from '@/components/データ/print/データPrint';
import CデータPrint from '@/components/データ/print/データPrint.vue';

import { 帳票Type } from '@/classes/service/Abstract計画PlbscfService';
import 差異分析Service from '@/classes/service/モニタリング/差異分析Service';
import 業績予測Service from '@/classes/service/モニタリング/業績予測Service';
import 計画PlbscfService from '@/classes/service/計画/計画PlbscfService';
import RoutesMixin from '@/entries/user/mixins/RoutesMixin';
import { PlbscfType } from '@/master/Plbscf';

export default mixins(RoutesMixin).extend({
  name: 'Pモニタリング',

  components: {
    CデータPrint,
  },

  data(): {
    eフェーズ種別: Eフェーズ種別;
    printDialogStyle: PrintDialogStyle;
    printConfigs: PrintConfig[];
  } {
    const v計画PlbscfService = new 計画PlbscfService(Eフェーズ種別.計画フェーズ);
    v計画PlbscfService.setIs帳票 = true;
    const v業績予測Service = new 業績予測Service(Eフェーズ種別.モニタリングフェーズ);
    v業績予測Service.setIs帳票 = true;
    const v差異分析Service = new 差異分析Service(Eフェーズ種別.モニタリングフェーズ);
    v差異分析Service.setIs帳票 = true;
    return {
      eフェーズ種別: Eフェーズ種別.モニタリングフェーズ,
      printDialogStyle: {
        width: '800px',
        top: '0vh',
        tableClass: 'monitoring',
      },
      printConfigs: [
        {
          name: '貸借対照表差異分析',
          service: v差異分析Service,
          with勘定科目: true,
          with部門: true,
          option: {
            計画PlbscfService: v計画PlbscfService,
            plbscfType: PlbscfType.貸借対照表,
          },
        },
        {
          name: '損益計算書差異分析',
          service: v差異分析Service,
          with勘定科目: true,
          with部門: true,
          referenceValue: Eモニタリング損益差異分析基準値,
          option: {
            referenceValue: Eモニタリング損益差異分析基準値.年度合計,
            計画PlbscfService: v計画PlbscfService,
            plbscfType: PlbscfType.損益計算書,
            帳票Type: 帳票Type.標準,
          },
        },
        {
          name: '損益計算書（部門別）差異分析',
          service: v差異分析Service,
          with勘定科目: true,
          with部門: true,
          referenceValue: Eモニタリング損益差異分析基準値,
          format: '全部門',
          option: {
            referenceValue: Eモニタリング損益差異分析基準値.年度合計,
            計画PlbscfService: v計画PlbscfService,
            plbscfType: PlbscfType.損益計算書,
            帳票Type: 帳票Type.部門別,
          },
        },
        {
          name: '貸借対照表業績予測',
          service: v業績予測Service,
          with勘定科目: true,
          with部門: true,
          referenceValue: Eモニタリング業績予測基準値,
          option: {
            referenceValue: Eモニタリング業績予測基準値.前期,
            計画PlbscfService: v計画PlbscfService,
            plbscfType: PlbscfType.貸借対照表,
            帳票Type: 帳票Type.標準,
          },
        },
        {
          name: '損益計算書業績予測',
          service: v業績予測Service,
          with勘定科目: true,
          with部門: true,
          referenceValue: Eモニタリング業績予測基準値,
          option: {
            referenceValue: Eモニタリング業績予測基準値.前期,
            計画PlbscfService: v計画PlbscfService,
            plbscfType: PlbscfType.損益計算書,
            帳票Type: 帳票Type.標準,
          },
        },
        {
          name: '損益計算書（部門別）業績予測',
          service: v業績予測Service,
          with勘定科目: true,
          with部門: true,
          referenceValue: Eモニタリング業績予測基準値,
          format: '全部門',
          option: {
            referenceValue: Eモニタリング業績予測基準値.前期,
            計画PlbscfService: v計画PlbscfService,
            plbscfType: PlbscfType.損益計算書,
            帳票Type: 帳票Type.部門別,
          },
        },
        {
          name: '損益計算書（科目別）業績予測',
          service: v業績予測Service,
          with勘定科目: true,
          with部門: true,
          referenceValue: Eモニタリング業績予測基準値,
          format: '全部門',
          option: {
            referenceValue: Eモニタリング業績予測基準値.前期,
            計画PlbscfService: v計画PlbscfService,
            plbscfType: PlbscfType.損益計算書,
            帳票Type: 帳票Type.科目別,
          },
        },
        {
          name: 'キャッシュフロー計算書業績予測',
          service: v業績予測Service,
          with勘定科目: true,
          with部門: true,
          referenceValue: Eモニタリング業績予測基準値,
          option: {
            referenceValue: Eモニタリング業績予測基準値.前期,
            計画PlbscfService: v計画PlbscfService,
            plbscfType: PlbscfType.CF計算書,
            帳票Type: 帳票Type.標準,
          },
        },
      ],
    };
  },
});
